const actions = {
  setState({ commit }, { state, optionalData }) {
    commit('SET_STATE', { state, optionalData })
  },
  unsetState({ commit }, newState) {
    commit('UNSET_STATE', newState)
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  },
}

export { actions }
